export default "__VITE_ASSET__Mwzu43hc__$_?url__"